import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import LoadingSpinner from '../components/LoadingSpinner'

export default function EventRedirect() {
  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    const redirectToRoleBasedEvent = async () => {
      try {
        // Get current user and their role
        const { data: { user } } = await supabase.auth.getUser()
        if (!user) {
          navigate('/login')
          return
        }

        const { data: userData } = await supabase
          .from('users')
          .select('user_type')
          .eq('id', user.id)
          .single()

        if (!userData) {
          navigate('/login')
          return
        }

        // Redirect based on role
        switch (userData.user_type) {
          case 'company_admin':
          case 'org_admin':
          case 'team_leader':
          case 'group_leader':
            navigate(`/admin/events/${id}`, { replace: true })
            break
          case 'subgroup_leader':
            navigate(`/subgroup-leader/events/${id}`, { replace: true })
            break
          case 'subgroup_member':
          case 'unassigned':
            navigate(`/member/events/${id}`, { replace: true })
            break
          default:
            navigate('/dashboard', { replace: true })
        }
      } catch (error) {
        console.error('Redirect error:', error)
        navigate('/dashboard', { replace: true })
      }
    }

    redirectToRoleBasedEvent()
  }, [id, navigate])

  return <LoadingSpinner message="Loading event..." />
}